import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { UploadStructure } from '../../../../property-editor/editors/upload/upload.structure';
import { AXFFormatService } from '../../../../services/format.service';
import { AXFUrlResolverService } from '../../../../services/url-resolver.service';
import { AXFWidgetView } from '../../../config/widget';

@Component({
  templateUrl: './image-widget.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AXFImageWidgetView extends AXFWidgetView {
  private _value!: UploadStructure;
  private dataSubscription: Subscription | undefined;

  @Input()
  public get value(): UploadStructure {
    return this._value;
  }
  public set value(v: UploadStructure) {
    if (JSON.stringify(v) !== JSON.stringify(this._value)) {
      this._value = v;
      this.dataService?.setValue(this.getPath() as string, v);
      this.cdr.detectChanges();
    }
  }

  constructor(
    private el: ElementRef<HTMLElement>,
    protected cdr: ChangeDetectorRef,
    private formatService: AXFFormatService,
    private resolverService: AXFUrlResolverService
  ) {
    super();
    //

    this.dataSubscription = this.dataService?.onChange.subscribe((data) => {
      if (this.value.srcData.startsWith('[$')) {
        let newFileId = this.formatService.format(this.value.srcData, this);
        // console.log('srcData called', this.value.srcData);
        // console.log('newFileId', newFileId);
        // console.log('data', this.resolveProperty);

        if (newFileId.includes('/')) {
          const arr = newFileId.split('/');
          newFileId = arr[arr.length - 1];
        }
        if (newFileId) {
          // console.log('newFileId called', newFileId);
          this.resolverService.resolve(newFileId).then((resolve) => {
            const _url = resolve;
            const linkSource = _url['changingThisBreaksApplicationSecurity'];
            this.el.nativeElement.children[0]['src'] = linkSource;
            // this.value.srcData = linkSource;
          });
        } else {
          this.el.nativeElement.children[0]['src'] =
            '../../../../../../assets/images/noimage.png';
        }
      }
    });
  }

  override onRender(): void {
    this.cdr.markForCheck();
  }

  override ngOnInit() {
    super.ngOnInit();
    if (this.value.srcData && this.value.srcData.match(/\[(.*?)\]/g)) {
      let imagurl = this.formatService.format(this.value.srcData, this);
      if (imagurl.includes('base64')) this.value.srcData = imagurl;
    }
  }
}
